import React from 'react';
import { useTranslation } from 'react-i18next';

import MDropdown from 'app/ui/MDropdown/MDropdown';

import { IDropdownListOption } from 'app/ui/MSelectList/MSelectList.model';

interface Props<ValueType extends string | number> {
  options: IDropdownListOption<ValueType>[];
  onClickOption: (optionIndex: number) => void;
}

const ProfileSettingsView = <ValueType extends string | number>(props: React.PropsWithChildren<Props<ValueType>>): JSX.Element => {
  const { t } = useTranslation();

  return (
    <MDropdown options={props.options} onClickOption={props.onClickOption}>
      {t('profileSettings.btnName')}
    </MDropdown>
  );
};

ProfileSettingsView.displayName = 'ProfileSettingsView';
ProfileSettingsView.defaultProps = {};

export default ProfileSettingsView;
